import { readFileSync } from "fs";

export default function (editor) {
  const { RichTextEditor } = editor;
  RichTextEditor.add("bulletedList", {
    icon: `<span class="fa fa-list-ul"></span>`,
    attributes: { title: "Bulleted List" },
    result: rte => rte.exec("insertUnorderedList"),
    state: rte => {
      const data = { el: rte.el, type: "bulletedList", enabled: true };
      editor.trigger("rte:action:button-status", data);
      if (!data.enabled) return -1;
      return 0;
    },
  });
  RichTextEditor.add("numberedList", {
    icon: `<span class="fa fa-list-ol"></span>`,
    attributes: { title: "Numbered List" },
    result: rte => rte.exec("insertOrderedList"),
    state: rte => {
      const data = { el: rte.el, type: "numberedList", enabled: true };
      editor.trigger("rte:action:button-status", data);
      if (!data.enabled) return -1;
      return 0;
    },
  });

  // always paste as plain text.
  editor.on("rte:enable", view => {
    const onPasteEvent = (e: ClipboardEvent) => {
      const text = e.clipboardData?.getData("text/plain") ?? "";
      e.preventDefault();
      view.activeRte.exec("insertText", text);
    };

    const el: HTMLElement = view.el;
    el.addEventListener("paste", onPasteEvent);
    editor.once("rte:disable", view => {
      const el: HTMLElement = view.el;
      el.removeEventListener("paste", onPasteEvent);
    });
  });

  editor.on("storage:loaded", () => {
    const canvasDoc = editor.Canvas.getDocument();
    const styleEl = canvasDoc.head.appendChild(canvasDoc.createElement("style"));
    styleEl.setAttribute("data-do-not-store", true);
    styleEl.innerHTML = readFileSync(__dirname + "/index.css", "utf-8");
  });

  const checkComponentEditable = model => {
    if (model.get("type") !== "text") return;
    if (model.closestType("text")) return;

    const parentStyle = getComputedStyle(model.parent().getEl());
    if (["flex", "inline-flex", "grid", "inline-grid"].includes(parentStyle.display)) {
      console.warn(
        `Text component with content "${
          model.getEl().innerHTML
        }" could not be changed to inline-block, turning off editing. Wrap content with <div> to enable editing.`
      );
      model.set({ editable: false, highlightable: false });
      model.addAttributes({ class: model.getEl().className + " not-editable" });
    }
  };

  editor.on("component:mount", model => setTimeout(() => checkComponentEditable(model), 0));
}
